import React from 'react';

import './shape.scss';


function Shape({shapeName, shapeClass}) {
  const className                 = `shape ${shapeClass}`;

  return (
    <span className={className}>
      <span>{shapeName}</span>
    </span>
  );
}

export default Shape;
